import { useTranslation } from "react-i18next";
//Components
import { DeletedPatientDiv, DeletedPatientText } from "./styles";

const DeletedPatientFromOrion = () => {
  const [t] = useTranslation("global");

  return (
    <DeletedPatientDiv>
      <DeletedPatientText>{t("deletePatient_deletedPatientMessage")}</DeletedPatientText>
    </DeletedPatientDiv>
  );
};

export default DeletedPatientFromOrion;
